const root = document.querySelector('.almc-recovery-measurement');
if (root) {
    const panel = root.querySelector('[data-measurement-panel]');
    const opener = root.querySelector('[data-measurement-open]');
    const error = root.querySelector('[data-measurement-error]');
    const buttons = [...root.querySelectorAll('[data-measurement-accept], [data-measurement-reject]')];
    const currentUrl = new URL(window.location.href);
    const reference = currentUrl.searchParams.get('oppref');
    const clicks = {};
    for (const key of ['gclid', 'gbraid', 'wbraid', 'fbclid']) {
        const value = currentUrl.searchParams.get(key);
        if (value && /^[A-Za-z0-9_.~-]{1,512}$/.test(value)) clicks[key] = value;
    }
    let google = null;
    let allowed = false;
    let resolved = false;
    let loaded = false;
    let measuring = false;
    let pendingSaves = [];
    const measured = new Set();
    let csrf = '';
    let busy = false;

    // One tag in the top document, so Tag Assistant can inspect both the landing and checkout.
    // Explicit public metadata excludes private case paths, query parameters and form contents.
    const publicPage = 'https://almc.es/es/reparar-web-hackeada';
    function publicMetadata(refs = clicks) {
        const url = new URL(publicPage);
        for (const key of ['gclid', 'gbraid', 'wbraid']) {
            if (/^[A-Za-z0-9_.~-]{1,512}$/.test(refs?.[key] || '')) url.searchParams.set(key, refs[key]);
        }
        return { page_location: url.href, page_referrer: '', page_title: 'ALMC · Recuperación web' };
    }
    function updateConsent(granted) {
        window.gtag?.('consent', 'update', { ad_storage: granted ? 'granted' : 'denied',
            // Measurement permission never authorizes collecting contact or technical access fields.
            ad_user_data: 'denied', ad_personalization: 'denied', analytics_storage: 'denied' });
    }
    function loadGoogle() {
        if (!allowed || !/^AW-\d+$/.test(google || '')) return false;
        if (loaded) return true;
        loaded = true;
        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
        window.gtag('consent', 'default', { ad_storage: 'denied', ad_user_data: 'denied',
            ad_personalization: 'denied', analytics_storage: 'denied' });
        window.gtag('set', { ...publicMetadata(), allow_enhanced_conversions: false,
            allow_ad_personalization_signals: false, allow_google_signals: false,
            url_passthrough: false, ads_data_redaction: true, user_data: null, user_id: null });
        updateConsent(true);
        window.gtag('js', new Date());
        window.gtag('config', google, { ...publicMetadata(), send_page_view: false,
            allow_enhanced_conversions: false, allow_ad_personalization_signals: false,
            cookie_expires: 2592000, cookie_update: false });
        const script = document.createElement('script');
        script.async = true;
        script.referrerPolicy = 'no-referrer';
        script.src = `https://www.googletagmanager.com/gtag/js?id=${google}`;
        root.dataset.googleTagState = 'loading';
        script.addEventListener('load', () => {
            if (allowed) root.dataset.googleTagState = 'ready';
        }, { once: true });
        script.addEventListener('error', () => {
            loaded = false;
            script.remove();
            if (allowed) root.dataset.googleTagState = 'failed';
        }, { once: true });
        document.head.append(script);
        return true;
    }
    function encodedReference() {
        if (!reference) return undefined;
        const bytes = new TextEncoder().encode(reference);
        if (bytes.length > 2048 || /[\x00-\x1f\x7f]/.test(reference)) return undefined;
        return btoa(String.fromCharCode(...bytes));
    }
    async function save(action, extra = {}) {
        const response = await fetch(root.dataset.updateUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CSRF-TOKEN': csrf },
            body: JSON.stringify({ action, click_ref_base64: action === 'reject' ? undefined : encodedReference(),
                clicks: action === 'reject' ? undefined : clicks, ...extra }),
        });
        if (!response.ok) throw new Error('Measurement preference unavailable');
        return response.json();
    }
    function measureRegistration(events = []) {
        if (!loadGoogle() || !Array.isArray(events)) return;
        for (const event of events) {
            if (!new RegExp(`^${google}/[A-Za-z0-9_-]+$`).test(event?.send_to || '')
                || event.value !== 0 || event.currency !== 'EUR'
                || !/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(event.transaction_id || '')) continue;
            const key = `almc:google-registration:${event.send_to}:${event.transaction_id}`;
            if (measured.has(key)) continue;
            try { if (window.sessionStorage.getItem(key)) continue; } catch { /* Storage is optional. */ }
            window.gtag('event', 'conversion', { send_to: event.send_to, value: 0,
                currency: 'EUR', transaction_id: event.transaction_id, ...publicMetadata(event.clicks),
                event_callback: () => {
                    // Persist only after Google processes the event, never while its SDK is still loading.
                    try { window.sessionStorage.setItem(key, '1'); } catch { /* Google also deduplicates transaction IDs. */ }
                } });
            measured.add(key);
        }
    }
    async function restoreRegistration() {
        const caseId = document.getElementById('id_url')?.value;
        if (!allowed || !google || measuring || !/^[a-f0-9-]{36}$/i.test(caseId || '')) return;
        measuring = true;
        try {
            const result = await save('events', { case_id: caseId });
            measureRegistration(result.events || []);
        }
        catch { /* Optional measurement never blocks the service. */ }
        finally { measuring = false; }
    }
    function measureSave(detail) {
        if (detail?.success !== true) return;
        if (!resolved) { pendingSaves.push(detail); pendingSaves = pendingSaves.slice(-10); return; }
        if (!loadGoogle()) return;
        // A successful edit is observable in Tag Assistant, but is never another primary conversion.
        window.gtag('event', 'form_submit', { send_to: google, form_id: 'recovery_checkout',
            form_status: detail.registration_created === true ? 'created' : 'updated', ...publicMetadata() });
        measureRegistration(detail.google_events || []);
    }
    function flushSaves() {
        const pending = pendingSaves;
        pendingSaves = [];
        pending.forEach(measureSave);
    }
    document.addEventListener('almc:registration-saved', event => measureSave(event.detail));
    async function choose(action) {
        if (busy) return;
        busy = true;
        buttons.forEach(button => { button.disabled = true; });
        error.hidden = true;
        try {
            await save(action);
            allowed = action === 'accept';
            resolved = true;
            if (allowed) { updateConsent(true); loadGoogle(); flushSaves(); await restoreRegistration(); }
            else {
                updateConsent(false);
                pendingSaves = [];
                root.dataset.googleTagState = 'disabled';
                for (const name of ['_gcl_aw', '_gcl_au', '_gcl_gb', '_gcl_gs']) {
                    document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax`;
                    document.cookie = `${name}=; Max-Age=0; Path=/; Domain=.${location.hostname}; SameSite=Lax`;
                }
            }
            panel.hidden = true;
        }
        catch { error.hidden = false; }
        finally { busy = false; buttons.forEach(button => { button.disabled = false; }); }
    }
    opener.addEventListener('click', () => { panel.hidden = false; error.hidden = true; });
    root.querySelector('[data-measurement-close]').addEventListener('click', () => { panel.hidden = true; });
    root.querySelector('[data-measurement-accept]').addEventListener('click', () => choose('accept'));
    root.querySelector('[data-measurement-reject]').addEventListener('click', () => choose('reject'));
    fetch(root.dataset.statusUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(response => response.ok ? response.json() : Promise.reject())
        .then(async status => {
            resolved = true;
            if (!status.enabled) { pendingSaves = []; return; }
            csrf = status.csrf;
            google = status.google;
            allowed = status.choice === true && status.modern;
            opener.hidden = false;
            const fromAd = encodedReference() || Object.keys(clicks).length > 0;
            if (allowed) {
                if (fromAd) await save('capture');
                loadGoogle(); flushSaves(); await restoreRegistration();
            } else {
                pendingSaves = [];
                if ((status.choice === null || (status.choice === true && !status.modern)) && fromAd) panel.hidden = false;
            }
        }).catch(() => { resolved = true; pendingSaves = []; /* Checkout remains usable. */ });
}
